module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4MOYu"))).then(() => parcelRequire('fThBo'));